import React from "react";
import { Panel } from "../../components/ui/dashboard";

const Charges: React.FC = () => {
  return (
    <div className="p-4 md:p-6">
      <Panel title="Charge Management" subtitle="Add and edit loading, toll, unloading and fuel surcharge">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Consignment ID" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Loading Charge" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Unloading Charge" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Toll / Road Tax" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Fuel Surcharge" />
          <input className="border rounded-lg px-3 py-2 text-sm" placeholder="Other Charges" />
        </div>
        <div className="mt-4 flex justify-end">
          <button className="px-3 py-2 rounded-lg text-sm bg-indigo-600 text-white">Save Charges</button>
        </div>
      </Panel>
    </div>
  );
};

export default Charges;